import devConfig from './development.config'

export default Object.assign(devConfig, {
  applicationKey: '99f0d44e-cc43-4279-9ff6-e94ac18fb4f4',
  applicationSecret: 'Dq8k141vouAndmiV2U5O0UOT',
  apiHost: 'https://privacy.aftvrsys.com'
})
